import i18n from '../../i18n'

export const locale = i18n.global.locale
